var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnterprise(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#iconEnterprise_svg__paint0_linear_4142_5404)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconEnterprise_svg__clip0_4142_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.49 25.784a.536.536 0 000-.235.559.559 0 00-.09-.246l-4.008-5.867a.53.53 0 000-.134.56.56 0 00-.571-.302H18.79a.55.55 0 00-.223.067.513.513 0 00-.09.09.495.495 0 00-.09.078l-4.287 6a.561.561 0 00-.101.28.55.55 0 000 .258.512.512 0 000 .079l13.3 14.957h.639L40.254 25.93a.502.502 0 000-.067s.236-.067.236-.079zm-13.223-5.25l3.157 4.478h-6.348l1.926-2.732 1.265-1.746zm3.583 5.598l-3.191 12.315-3.863-12.316h7.054zm-4.479 11.98L15.803 26.12h6.818l3.75 11.991zm5.598-11.98h6.785l-9.863 12.002 3.078-12.003zm.65-1.12l3.123-4.478 3.124 4.478H32.62zm2.049-4.893l-3.124 4.479-3.124-4.479h6.248zm-10.401 2.732l-1.232 1.747-2.665-3.784-.492-.695h6.314l-1.925 2.732zm-5.475-2.317l2.676 3.773.492.694h-6.326l3.158-4.467z",
    fill: "#058181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconEnterprise_svg__paint0_linear_4142_5404",
    x1: 27.5,
    y1: 0,
    x2: 27.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F4FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iconEnterprise_svg__clip0_4142_5404"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 19)",
    d: "M0 0h26.546v22H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterprise);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconEnterprise.f3d6db2e.svg";
export { MemoForwardRef as ReactComponent };